module.exports = __webpack_public_path__ + "img/inq_empty.4fffe845.png";